import {
  PayloadAction,
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
import http from "../../utils/http";

const DISMISSED_STORAGE_KEY = "maintenance-dismissed";
export const MAINTENANCE_DISMISSED_STORAGE_KEY = DISMISSED_STORAGE_KEY;

export type MaintenanceWindow = {
  id: string;
  message: string;
  startsAt: string;
  endsAt: string;
  createdBy?: string | null;
  createdAt?: string;
  updatedAt?: string;
};

export interface MaintenanceSlice {
  window: MaintenanceWindow | null;
  dismissed: boolean;
  loading: boolean;
}

const initialState: MaintenanceSlice = {
  window: null,
  dismissed: localStorage.getItem(DISMISSED_STORAGE_KEY) === "true",
  loading: false,
};

export const fetchActiveMaintenance = createAsyncThunk<
  MaintenanceWindow | null
>("maintenance/fetchActive", async () => {
  const res = await http.get("maintenance-schedule/active");
  return (res?.data?.data ?? null) as MaintenanceWindow | null;
});

export const maintenanceSlice = createSlice({
  name: "maintenance",
  initialState,
  reducers: {
    setMaintenanceWindow: (
      state,
      action: PayloadAction<MaintenanceWindow | null>
    ) => {
      state.window = action.payload;
      if (action.payload) {
        localStorage.removeItem(DISMISSED_STORAGE_KEY);
        state.dismissed = false;
      }
    },
    dismissMaintenance: (state) => {
      state.dismissed = true;
    },
    reset: (state) => ({
      window: state.window,
      dismissed: false,
      loading: false,
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActiveMaintenance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchActiveMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.window = action.payload;
      })
      .addCase(fetchActiveMaintenance.rejected, (state) => {
        state.loading = false;
        state.window = null;
      });
  },
});

export const { setMaintenanceWindow, dismissMaintenance, reset } =
  maintenanceSlice.actions;

export default maintenanceSlice.reducer;
